import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_USER_URL , API_OAUTH2_URL , API_LOGOUT_URL } from './utils/apiUrlList';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // check for error in query string (backend may redirect with ?error=...)
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    if (error !== null) {
      alert('Login failed: ' + error + '\n\nPlease check your credentials or Azure AD configuration.');
      window.history.replaceState({}, document.title, '/');
    }

    fetch(API_USER_URL, { credentials: 'include' })
      .then(response => {
        if (response.ok) return response.json();
        return null;
      })
      .then(data => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, []);

  const login = () => {
    // redirect to backend OAuth2 authorization endpoint
    // window.location.href = API_OAUTH2_URL;
     const currentDomain = encodeURIComponent(window.location.origin); 
     window.location.href = `${API_OAUTH2_URL}?redirect_uri=${currentDomain}`; 
  };
  

  const logout = () => {
    setUser(null);
     const currentOrigin = encodeURIComponent(window.location.origin);   
     window.location.href = `${API_LOGOUT_URL}?redirect_uri=${currentOrigin}`; 
    // window.location.href = currentOrigin;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
